import React, { useEffect, useState } from "react";
import GlobalPlansService from "../../../Services/GlobalPlansService";
import PlansTray from "./PlansTray";
import MicroLoader from "../../Alert_Popup/MicroLoader";
import World from "../../../assets/img/mapicons/World.png";
import mini_icon from "../../../assets/img/mapicons/global_icon/mini.jpg";
import std_icon from "../../../assets/img/mapicons/global_icon/std.jpg";
import full_icon from "../../../assets/img/mapicons/global_icon/full.jpg";
import large_icon from "../../../assets/img/mapicons/global_icon/large.jpg";
import { IoMdArrowDropdown } from "react-icons/io";
import "../../../scss/flag-sprite.css"

const GlobalESim = ({
  setRecurringModal,
  recurringModal,
  setModalData,
  openCoverageDropdownForGlobal,
  globalCountries,
  setCurrentDetails,
  setDetailsOpen,
  setSubPlan,
  subPlan,
  suggestion,
  vendorId,
  isTopPlan,
  setShoweKycPopup,
  resetTheFilterValue,
  setResetTheFilterValue

}) => {
  const [showPlansTray, setShowPlansTray] = useState(false);
  const [selectedGlobal, setSelectedGlobal] = useState({});
  const [globalPlans, setGlobalPlans] = useState({});
  const [message, setMessage] = useState();
  const [statusCode, setStatusCode] = useState();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    globalCategoryList();
  }, []);
  useEffect(() => {
    if (suggestion) {
      if (globalPlans.length > 0) {
        const selectedGlobal = globalPlans?.find(
          (item) => item.globalCategoryId == suggestion
        );
        setSelectedGlobal(selectedGlobal);
        setShowPlansTray(true);
      }
    }
  }, [suggestion, globalPlans]);
  const globalCategoryList = () => {
    GlobalPlansService.globalCategoryList().then((response) => {
      setGlobalPlans(response.data);
    }).catch((error) => {
      setIsLoading(false);
      if (error.message === "Network Error") {
        setMessage("Something went wrong, Please try again later");
      } else {
        setMessage(error.response.data.failedReason);
        setStatusCode(error.response ? error.response.status : "");
      }
    }
    );
  };

  // const globalPlans = [
  //   {
  //     globalId: 1,
  //     globalDescription: "Small Coverage",
  //     country: 4,
  //   },
  //   {
  //     globalId: 2,
  //     globalDescription: "Standard Coverage",
  //     country: 9,
  //   },
  //   {
  //     globalId: 3,
  //     globalDescription: "Large Coverage",
  //     country: 16,
  //   },
  //   {
  //     globalId: 4,
  //     globalDescription: "Full Coverage",
  //     country: 24,
  //   },
  // ];

  return (
    <>
      {!showPlansTray ? (
        <>
          {globalPlans && globalPlans.length > 0 ? (
            <div className="regional-esim-destination mt-4">
              <div className="regional-plans-grid">
                {globalPlans.map((item, index) => (
                  <div
                    className={`grid-card h-auto`}
                    key={item.globalCategoryId}
                  >
                    <div className="w-100 h-auto py-2 d-flex justify-content-start align-items-center">
                      <span style={{ width: '50px', height: '100%' }} className={`fflag ff-xl ff-round mr-2`}>
                        <img
                          className={`${item.globalCategoryId}-Logo w-100`}
                          src={
                            item.globalCategoryId === 1
                              ? mini_icon
                              : item.globalCategoryId === 2
                                ? std_icon
                                : item.globalCategoryId === 3
                                  ? large_icon
                                  : item.globalCategoryId === 4
                                    ? full_icon
                                    : null
                          }
                        />
                      </span>
                      <div>
                        <p
                          onClick={() => {
                            setShowPlansTray(true);
                            setSelectedGlobal(item);
                          }}
                          style={{lineHeight: '1.2'}}
                          className="m-0 region-title"
                        >
                          {item.globalCategoryDescription}
                        </p>

                        <div
                          onClick={() => {
                            openCoverageDropdownForGlobal(
                              index,
                              item.globalCategoryId
                            );
                            // open coverage dropdown here
                          }}
                          className="countries-label-dropdown d-flex justify-content-start align-items-center"
                        >
                          {item.planCountries && (
                            <span>{item.planCountries.length} Countries</span>
                          )}
                          <IoMdArrowDropdown />
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{
                height: "250px",
              }}
            >
              <MicroLoader />
            </div>
          )}
        </>
      ) : (
        <PlansTray
          isTopPlan={isTopPlan}
          planType="global"
          setRecurringModal={setRecurringModal}
          recurringModal={recurringModal}
          setSubPlan={setSubPlan}
          subPlan={subPlan}
          tab={"3"}
          setModalData={setModalData}
          openCoverageDropdownForGlobal={openCoverageDropdownForGlobal}
          globalCountries={globalCountries}
          setCurrentDetails={setCurrentDetails}
          setDetailsOpen={setDetailsOpen}
          selected={selectedGlobal}
          setShowPlansTray={setShowPlansTray}
          vendorId={vendorId}
          setShoweKycPopup={setShoweKycPopup}
          resetTheFilterValue={resetTheFilterValue}
          setResetTheFilterValue={setResetTheFilterValue}
        />
      )}
    </>
  );
};

export default GlobalESim;
